import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { CatalogService } from '@shared/services/catalog.service';
import { map } from 'rxjs/operators';
import { ImpairedPaginationComponent } from '@impairedShared/impaired-pagination/impaired-pagination/impaired-pagination.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent {
  @ViewChild('paginator', { static: true }) public paginator: ImpairedPaginationComponent;
  public allCatalogCount$ = this.catalogService
    .getCatalogs({ offset: 0, limit: 1, criteria: "publicCatalogStatus in ('Опубликовано')" })
    .pipe(map(res => res.found));

  constructor(private catalogService: CatalogService) {}

  public resetPaginator(currentCount: number): void {
    this.paginator.currentCount = currentCount;
    this.paginator.pageIndex = 1;
    this.paginator.pageIndexChange(false);
  }
}
